import React from 'react';
import '../styles/Decorations.css';

export default function Decorations() {
  return (
    <div className="decorations" aria-hidden="true">
      <img className="decor deco-bird-blue" src="/assets/icons/blue_bird.png" alt="" />
      <img className="decor deco-bird-yellow" src="/assets/icons/yellow_bird.png" alt="" />
      <img className="decor deco-bird-blue-2" src="/assets/icons/blue_bird.png" alt="" />
      <img className="decor deco-bird-yellow-2" src="/assets/icons/yellow_bird.png" alt="" />

      <img className="decor deco-heart" src="/assets/icons/heart.png" alt="" />
      <img className="decor deco-heart-2" src="/assets/icons/heart.png" alt="" />
      <img className="decor deco-star" src="/assets/icons/12_angle_star.png" alt="" />
      <img className="decor deco-star-2" src="/assets/icons/12_angle_star.png" alt="" />

      <img className="decor deco-flower-min" src="/assets/icons/min_flower.png" alt="" />
      <img className="decor deco-flower-mid" src="/assets/icons/mid_flower.png" alt="" />
      <img className="decor deco-flower-min-2" src="/assets/icons/min_flower.png" alt="" />
      <img className="decor deco-flower-mid-2" src="/assets/icons/mid_flower.png" alt="" />

      <img className="decor deco-bush" src="/assets/icons/bush.png" alt="" />
      <img className="decor deco-bush-2" src="/assets/icons/bush.png" alt="" />

      <img className="decor deco-home" src="/assets/icons/home.png" alt="" />
    </div>
  );
}
